import { Modal } from "react-bootstrap";
import { useEffect } from "react";
import { toast } from "react-toastify";
import useFlow from "../hooks/useFlow";
import { clearHubSpotState } from "../utils/hubspot";

export default function OfferingModal() {
  const {
    showOfferingModal,
    setShowOfferingModal,
    pendingOffering,
    setPendingOffering,
    trackOffering,
    recordOfferingInterested,
  } = useFlow();

  const rawClient = pendingOffering?._client;
  const clientId = rawClient?.id ?? rawClient?.Id;

  useEffect(() => {
    if (showOfferingModal && pendingOffering?.id && clientId) {
      trackOffering(pendingOffering.id, "displayed", {}, clientId);
    }
  }, [showOfferingModal, pendingOffering?.id, clientId]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClose = () => {
    setShowOfferingModal(false);
    setPendingOffering(null);
    clearHubSpotState();
  };

  const handleInterested = async () => {
    if (!pendingOffering?.id || !rawClient) return;
    trackOffering(pendingOffering.id, "interested", {}, clientId);
    await recordOfferingInterested(
      pendingOffering.id,
      rawClient,
      pendingOffering.product
    );
    toast.success("Thanks! We'll send you the details soon.");
    handleClose();
  };

  const handleNotInterested = () => {
    if (pendingOffering?.id) {
      trackOffering(pendingOffering.id, "not_interested", {}, clientId);
    }
    toast.success("Thanks! We won't show this again.");
    handleClose();
  };

  if (!pendingOffering) return null;

  const { title, reason, product } = pendingOffering;

  return (
    <Modal
      show={showOfferingModal}
      onHide={handleClose}
      centered
      size="lg"
    >
      <Modal.Body className="text-center p-4">
        <div className="modal-header border-0 m-0 p-3">
          <h4 className="text-center w-100 pb-0 mb-0">
            {title}
          </h4>
        </div>

        <div className="modal-body pl-4 pr-4">
          {reason && (
            <p className="text-center p-0 pb-3">
              {reason}
            </p>
          )}

          {product && (
            <div className="bg-light rounded-4 p-4 mb-4">
              <h5 className="mb-2">{product.name}</h5>
              <p className="mb-0 fs-4">
                <small className="fw-light">$</small>
                <strong>{product.price?.toFixed(2)}</strong>
              </p>
            </div>
          )}
        </div>

        <div className="modal-footer border-0 flex-column gap-2">
          <button
            className="btn btn-primary btn-lg w-100"
            data-testid="offering-interested-btn"
            onClick={handleInterested}
          >
            Interested
          </button>
          <button
            className="btn btn-outline-secondary btn-lg w-100"
            data-testid="offering-not-interested-btn"
            onClick={handleNotInterested}
          >
            Not interested
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
